import { all, fork } from "redux-saga/effects";
import * as filtersSaga from "./filters";
import * as mapSaga from "./map";
import * as linkRestrictionSaga from "./linkRestriction";
import * as authenticationSaga from "./authentication";
import * as citySaga from "./city";
import * as mapLayerSaga from "./mapLayer";
import * as userSaga from "./user";
import * as regulationSaga from "./regulation/regulation";
import * as proposedLinksSaga from "./regulation/proposedLinks";
import * as batchListViewSaga from "./batchListView";
import * as regulationListViewSaga from "./regulation/listview";
import * as CreateRegulationSaga from "./regulation/CreateRegulation";
import * as publicViewerSaga from "./publicViewer";
import * as assetDataSaga from "./assets";
import * as multiLingualSaga from "./multilingual";
import * as liveDataSaga from "./liveData";
import * as scenarios from "./scenarios";
import * as Analyzer from "./Analyzer";
import * as regulationTemplates from "./regulation/regulationTemplates";
import * as WorkOrders from "./workOrder";
import * as Dashboards from "./dashboards";
import * as editBatchSelection from "./editBatchSelection";
import * as proposedParkingRateSaga from "./regulation/proposedParkingRate";
import * as projects from "./projects";

function* rootSaga() {
    yield all(
        [
            ...Object.values(filtersSaga),
            ...Object.values(mapSaga),
            ...Object.values(linkRestrictionSaga),
            ...Object.values(authenticationSaga),
            ...Object.values(citySaga),
            ...Object.values(mapLayerSaga),
            ...Object.values(userSaga),
            ...Object.values(regulationSaga),
            ...Object.values(proposedLinksSaga),
            ...Object.values(batchListViewSaga),
            ...Object.values(regulationListViewSaga),
            ...Object.values(publicViewerSaga),
            ...Object.values(CreateRegulationSaga),
            ...Object.values(assetDataSaga),
            ...Object.values(multiLingualSaga),
            ...Object.values(liveDataSaga),
            ...Object.values(scenarios),
            ...Object.values(Analyzer),
            ...Object.values(regulationTemplates),
            ...Object.values(WorkOrders),
            ...Object.values(Dashboards),
            ...Object.values(editBatchSelection),
            ...Object.values(proposedParkingRateSaga),
            ...Object.values(projects)
        ].map(fork)
    );
}

export default rootSaga;
